import React from 'react';
import cn from 'classnames';

type Props = {
  text: string;
  status?: 'error' | 'success';
  disabled?: boolean;
} & React.HTMLAttributes<HTMLSpanElement>;

const HelperText = ({ text, status, disabled, className, ...rest }: Props) => {
  return (
    <span
      className={cn(
        'text-xs font-normal text-[#777777] dark:text-dark-text-secondary',
        {
          '!text-red-500 dark:!text-red-400': status === 'error',
          '!text-dark-success': status === 'success',
          '!text-light-text-secondary': disabled,
        },
        className
      )}
      {...rest}
    >
      {text}
    </span>
  );
};

export default HelperText;
